import { render, staticRenderFns } from "./Upf.vue?vue&type=template&id=7b362e9f&"
import script from "./Upf.vue?vue&type=script&lang=js&"
export * from "./Upf.vue?vue&type=script&lang=js&"
import style0 from "./Upf.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports